import React, { useState, useEffect, useMemo, useCallback } from "react";
import Swal from "sweetalert2";
import moment from "moment";
import WithdrawalList from "../../components/Withdrawal/WithdrawalList";
import WithdrawalService from "../../services/withdrawalService";
import WithdrawalForm from "../../components/Withdrawal/WithdrawalForm";
import WithdrawalDetail from "../../components/Withdrawal/WithdrawalDetail";

const WithdrawalContainer = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [stock, setStock] = useState([]);
  const [onOpen, setOnOpen] = useState(false);
  const todayDate = moment().format("YYYY-MM-DD");
  const userId = Number(localStorage.getItem("userId"));
  const userName = localStorage.getItem("screenname");
  const storedRoles = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("userRoles") || "[]");
    } catch {
      return [];
    }
  }, []);
  const [canManageWithdrawals, setCanManageWithdrawals] = useState(
    storedRoles.some((role) => String(role).toLowerCase() === "admin")
  );
  const [area, setArea] = useState("");
  const [selectedStock, setSelectedStock] = useState(null);
  const [lines, setLines] = useState([]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailData, setDetailData] = useState(null);
  //traemos el area de la base
  const getArea = useCallback(async () => {
    try {
      const data = await WithdrawalService.getArea(userId);
      console.log("data.area", data.area);
      setArea(data.area);
    } catch (error) {
      console.error(error);
    }
  }, [userId]);

  const getWithdrawal = useCallback(async () => {
    try {
      const sendData = {
        userId,
      };
      const data = await WithdrawalService.getAllWithdrawals(sendData);
      setWithdrawals(data.withdrawal);
      setCanManageWithdrawals(Boolean(data.canManageWithdrawals));
    } catch (error) {
      console.error(error);
    }
  }, [userId]);

  const getAllStockAsigned = useCallback(async () => {
    try {
      const data = await WithdrawalService.getAllStockAsigned(userId);
      setStock(data.stock);
    } catch (error) {
      console.error(error);
    }
  }, [userId]);

  useEffect(() => {
    getWithdrawal();
    getAllStockAsigned();
    getArea();
  }, [getAllStockAsigned, getArea, getWithdrawal, userId]);

  // tipo carrtito
  const rawStockOptions = useMemo(
    () =>
      Array.isArray(stock)
        ? stock.map((row) => {
            const id = row?.Stock?.id ?? row?.id_stock ?? row?.id;
            const description =
              row?.Stock?.description ??
              row?.description ??
              row?.name ??
              `Item ${id}`;
            const available =
              Number(
                row?.Stock?.available ??
                  row?.available ??
                  row?.qty ??
                  row?.quantity ??
                  row?.cantidad ??
                  1
              ) || 1;

            return { id, description, available };
          })
        : [],
    [stock]
  );

  //quita de la lista lo seeleccion
  const takenById = useMemo(() => {
    const acc = {};
    for (const it of lines) acc[it.stockId] = (acc[it.stockId] || 0) + 1;
    return acc;
  }, [lines]);

  //select opciones
  const stockOptions = useMemo(() => {
    if (!Array.isArray(rawStockOptions)) return [];

    const opts = rawStockOptions.map((o) => ({
      ...o,
      label: o.description,
    }));

    // Ocultar los que ya están seleccionados
    const filtered = opts.filter((o) => !(takenById[o.id] >= 1));

    return filtered;
  }, [rawStockOptions, takenById]);

  const onSelectStock = (val) => {
    if (val && typeof val === "object") setSelectedStock(val);
    else {
      const found = stockOptions.find((o) => o.id === val) || null;
      setSelectedStock(found);
    }
  };

  const onAddItem = () => {
    if (!selectedStock) return;

    setLines((prev) => [
      ...prev,
      { stockId: selectedStock.id, description: selectedStock.description },
    ]);
    setSelectedStock(null);
  };

  const selectedList = useMemo(() => {
    const map = new Map();
    for (const it of lines) {
      const key = it.stockId;
      if (!map.has(key))
        map.set(key, {
          stockId: it.stockId,
          description: it.description,
          count: 0,
        });
      map.get(key).count += 1;
    }
    return Array.from(map.values());
  }, [lines]);

  const onRemoveOne = (stockId) => {
    setLines((prev) => {
      const idx = prev.findIndex((l) => l.stockId === stockId);
      if (idx === -1) return prev;
      const clone = [...prev];
      clone.splice(idx, 1); // quita sólo 1
      return clone;
    });
  };

  const handleOpenForm = () => {
    setOnOpen(true);
  };
  const handleCloseForm = () => {
    setOnOpen(false);
  };

  const handleViewDetail = (row) => {
    setDetailData(row);
    setDetailOpen(true);
  };
  const handleCloseDetail = () => {
    setDetailOpen(false);
    setDetailData(null);
  };
  //guardamos la solicitud
  const onSubmitHeader = async (header) => {
    if (lines.length === 0) return;

    const vpnNames = [];
    if (header.vpn?.banka) vpnNames.push("Banka");

    const payload = {
      header: {
        employeeId: userId,
        approverId: null,
        fechaRetiro: header.fechaRetiro || todayDate,
        fechaDevolucion: header.fechaDevolucion,
        motivo: header.motivo.toUpperCase() || "",
        details: header.comments || "",
        cargo: header.cargo.toUpperCase(),
        vpnNames,
        vpnActivationRequested: header.vpn?.banka || false,
      },
      lines: lines.map((l) => ({ stockId: l.stockId })),
    };
    try {
      const result = await WithdrawalService.createWithdrawal(payload);

      await Swal.fire({
        icon: "success",
        title: "Solicitud de retiro creada",
        text: `Solicitud #${result?.id || ""} creada correctamente.`,
        timer: 1400,
        showConfirmButton: false,
      });

      // refrescar lista y limpiar
      await getWithdrawal();
      setLines([]);
      setSelectedStock(null);
      setOnOpen(false);
    } catch (err) {
      console.error("createWithdrawal error:", err);
      Swal.fire({
        icon: "error",
        title: "No se pudo guardar",
        text:
          err?.response?.data?.resp ||
          err?.response?.data?.message ||
          "Revisá la consola / Network para más detalles.",
      });
    }
  };

  //aprobamos la solicitud
  const approve = async (withdrawal) => {
    try {
      const needsVpnActivation = Boolean(withdrawal?.vpnActivationRequested);
      const vpnWindow = needsVpnActivation
        ? `Se programará desde las 00:00 de la fecha de retiro hasta las 23:59 de la fecha de devolución.`
        : "La solicitud no pidió activación de VPN Banka.";
      const result = await Swal.fire({
        title: "Esta seguro de Aprobar o Rechazar la solicitud?",
        html: needsVpnActivation
          ? `<div style="text-align:left">
              <p>La persona solicitó activar <b>VPN Banka</b>.</p>
              <p style="font-size:13px;color:#555">${vpnWindow}</p>
              <label style="display:flex;align-items:center;gap:8px;margin-top:12px">
                <input type="checkbox" id="vpnActivationApproved" checked />
                <span>Activar VPN Banka durante el periodo solicitado</span>
              </label>
            </div>`
          : `<p style="font-size:14px;color:#555">${vpnWindow}</p>`,
        icon: "question",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Aprobar",
        denyButtonText: "Rechazar",
        preConfirm: () => ({
          vpnActivationApproved: needsVpnActivation
            ? Boolean(document.getElementById("vpnActivationApproved")?.checked)
            : false,
        }),
      });
      if (!result.isConfirmed && !result.isDenied) {
        return; // cancelado
      }

      const status = result.isConfirmed ? 2 : 3;
      const statusData = {
        status,
        id: withdrawal?.id,
        userId,
        vpnActivationApproved: result.isConfirmed
          ? Boolean(result.value?.vpnActivationApproved)
          : false,
      };

      Swal.fire({
        title: "Guardando...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      await WithdrawalService.approveWithdrawal(statusData);

      //exito
      await Swal.fire({
        icon: "success",
        title: result.isConfirmed
          ? "Solicitud aprobada"
          : "Solicitud rechazada",
        timer: 1400,
        showConfirmButton: false,
      });
      await getWithdrawal();
    } catch (err) {
      console.error("approveWithdrawal error:", err);
      Swal.fire({
        icon: "error",
        title: "No se pudo aprobar / rechazar la solicitud",
        text:
          err?.response?.data?.resp ||
          err?.response?.data?.message ||
          "Revisá la consola / Network para más detalles.",
      });
    }
  };

  return (
    <>
      <WithdrawalList
        data={withdrawals}
        onOpen={handleOpenForm}
        onViewDetail={handleViewDetail}
        canManageWithdrawals={canManageWithdrawals}
        approve={approve}
        currentUserId={userId}
      />
      <WithdrawalForm
        onOpen={onOpen}
        onClose={handleCloseForm}
        userName={userName}
        todayDate={todayDate}
        data={withdrawals}
        stockOptions={stockOptions}
        selectedStock={selectedStock}
        onSelectStock={onSelectStock}
        onAddItem={onAddItem}
        selectedList={selectedList}
        onRemoveOne={onRemoveOne}
        onSubmitHeader={onSubmitHeader}
        area={area}
      />
      <WithdrawalDetail
        open={detailOpen}
        onClose={handleCloseDetail}
        data={detailData}
      />
    </>
  );
};

export default WithdrawalContainer;
